import request from "@/utils/request";
import nativeApi from '@/utils/native-bridge.js'

import {
	getToken
} from "@/utils/auth";
export function previewUrl(fileId) {
	return process.env.VUE_APP_API_URL + '/app/file/preview?fileId=' + fileId + '&token=' + getToken()
}

export function previewFile(fileUrl) {
	const isClient = nativeApi.getWeirenClientInfo()
	if (isClient) {
		nativeApi.openWebBrowser(fileUrl);
	} else {
		let a = document.createElement('a')
		a.setAttribute('href', fileUrl);
		a.setAttribute('target', '_blank');
		a.click();
	}
}


export function getFileInfo(fileId) {
	return request({
		url: '/file/info?fileId=' + fileId,
		method: 'get'
	})
}

export function downloadUrl(fileId) {
	return process.env.VUE_APP_API_URL + '/app/file/download?fileId=' + fileId + '&token=' + getToken()
}
